/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ITechnicalExpertiseDataState } from "../../Interfaces/SiteContent";
import {
  IGetTechnicalExpertiseFailure,
  IGetTechnicalExpertiseSuccess,
} from "./TechnicalExpertiseAction";
import {
  TECHNICAL_EXPERTISE_LOAD_FAILURE,
  TECHNICAL_EXPERTISE_LOAD_SUCCESS,
} from "./TechnicalExpertiseTypes";

const initialState: ITechnicalExpertiseDataState = {
  technicalExpertise: [],
  technicalExpertiseOptionList: [],
  technicalExpertiseLoadError: "",
};

/**
 * Updates state of fetch technical expertise success.
 * @param {ITechnicalExpertiseDataState} state The technical expertise state.
 * @param {IGetTechnicalExpertiseSuccess} action The technical expertise action success.
 * @returns {ITechnicalExpertiseDataState} New technical expertise state.
 */
const applyLoadTechnicalExpertise = (
  state: ITechnicalExpertiseDataState,
  action: IGetTechnicalExpertiseSuccess
): ITechnicalExpertiseDataState => ({
  ...state,
  technicalExpertise: action.technicalExpertise,
  technicalExpertiseOptionList: action.technicalExpertise.map((x) => ({
    key: x.text,
    text: x.technicalExpertiseLocKey,
  })),
});

/**
 * Updates state of fetch technical expertise failure.
 * @param {ITechnicalExpertiseDataState} state The technical expertise state.
 * @param {IGetTechnicalExpertiseFailure} action The technical expertise action failure.
 * @returns {ITechnicalExpertiseDataState} New technical expertise state.
 */
const applyLoadFailTechnicalExpertise = (
  state: ITechnicalExpertiseDataState,
  action: IGetTechnicalExpertiseFailure
): ITechnicalExpertiseDataState => ({
  ...state,
  technicalExpertiseLoadError: action.technicalExpertiseLoadError,
});

/**
 * Reducer function for Activity component.
 * @param {ITechnicalExpertiseDataState} state The activity state.
 * @param {TechnicalExpertiseActionTypes} action The action type.
 * @returns {ITechnicalExpertiseDataState} The activity state.
 */

function TechnicalExpertiseReducer(
  state: ITechnicalExpertiseDataState = initialState,
  action
): ITechnicalExpertiseDataState {
  switch (action.type) {
    case TECHNICAL_EXPERTISE_LOAD_SUCCESS:
      return applyLoadTechnicalExpertise(state, action);
    case TECHNICAL_EXPERTISE_LOAD_FAILURE:
      return applyLoadFailTechnicalExpertise(state, action);
    default:
      return state;
  }
}

export default TechnicalExpertiseReducer;
